import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { AdminGuard } from '../core/guards/admin.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const ADMIN_ROUTES: Routes = [
  {
    path: 'animations3d/list',
    loadComponent: () => import('../features/animations3d/list/list.component').then(m => m.Animations3dListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'etablissement/list',
    loadComponent: () => import('../features/ehpad/list/list.component').then(m => m.EhpadListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'etablissement/add',
    loadComponent: () => import('../features/ehpad/add/add.component').then(m => m.EhpadAddComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'etablissement/edit/:id',
    loadComponent: () => import('../features/ehpad/edit/edit.component').then(m => m.EhpadEditComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'etablissement/sso/:id',
    loadComponent: () =>
      import('../features/ehpad/sso-config/ehpad-sso-page.component').then(m => m.EhpadSsoPageComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'sso-equipe',
    loadComponent: () =>
      import('../features/ehpad/sso-config/platform-sso-page.component').then(
        (m) => m.PlatformSsoPageComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'etablissement/view/:id',
    loadComponent: () => import('../features/ehpad/view/view.component').then(m => m.EhpadViewComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  // Compat anciennes URLs /ehpad/*
  { path: 'ehpad/list', redirectTo: 'etablissement/list', pathMatch: 'full' },
  { path: 'ehpad/add', redirectTo: 'etablissement/add', pathMatch: 'full' },
  { path: 'ehpad/edit/:id', redirectTo: 'etablissement/edit/:id' },
  { path: 'ehpad/sso/:id', redirectTo: 'etablissement/sso/:id' },
  { path: 'ehpad/view/:id', redirectTo: 'etablissement/view/:id' },
  {
    path: 'export/user-data',
    loadComponent: () =>
      import('../features/export-user-data/export-user-data.component').then(m => m.ExportUserDataComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'rgpd/proofs',
    loadComponent: () =>
      import('../features/rgpd-retention/proofs-list/proofs-list.component').then(
        (m) => m.RgpdProofsListComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'rgpd/incident-dossier',
    loadComponent: () =>
      import('../features/rgpd-retention/incident-dossier/incident-dossier.component').then(
        (m) => m.RgpdIncidentDossierComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'maintenance/list',
    loadComponent: () => import('../features/maintenance/list/list.component').then(m => m.MaintenanceListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'system-monitoring',
    loadComponent: () =>
      import('../features/system-monitoring/system-monitoring.component').then(
        (m) => m.SystemMonitoringComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'headscale/machines',
    loadComponent: () =>
      import('../features/headscale-machines/headscale-machines.component').then(
        (m) => m.HeadscaleMachinesComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'gestionnaire/list',
    loadComponent: () => import('../features/users/gestionnaire/list/list.component').then(m => m.GestionnaireListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'techniciens/list',
    loadComponent: () => import('../features/users/technicien/list/list.component').then(m => m.TechnicienListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'gestionnaire/add',
    loadComponent: () => import('../features/users/gestionnaire/add/add.component').then(m => m.GestionnaireAddComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'gestionnaire/edit/:id',
    loadComponent: () => import('../features/users/gestionnaire/edit/edit.component').then(m => m.GestionnaireEditComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'audios/list',
    loadComponent: () => import('../features/audios/list/list.component').then(m => m.AudiosListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'app-versions/list',
    loadComponent: () => import('../features/app-versions/list/list.component').then(m => m.AppVersionsListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD, ROLES.TECH],
    },
  },
  {
    path: 'roles/list',
    loadComponent: () => import('../features/roles/list/list.component').then(m => m.RolesListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'fonctions/list',
    loadComponent: () => import('../features/fonctions/list/list.component').then(m => m.FonctionsListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
];
